import React, { useState, useEffect, useCallback } from "react";
import { Grid, Divider } from "@mui/material";
import GoogleLogin from "./GoogleLogin";
import { GoogleOAuthProvider } from "@react-oauth/google";
import AllMyTask from "./AllMyTask";
import MyPlannerTasks from "./MyPlannerTasks";
import "./GoogleLogin.scss";
import { currentUserPlannerToken } from "../../../utils/constants";
import { useResponsive } from "../../../hooks/useResponsive";
import "./planner-mobile-responsive.scss";
import { useSearchParams } from "react-router-dom";
import { localStorageInstance } from "../../../utils/localStorage";
import { apiGoogleCallback } from "../../../sevices/apiGoogleAuth";
import { useRemoveMultipleParams } from "../../../hooks/useRemoveMultipleParams";
import Loader from "../../../components/Loader";
import toast from "react-hot-toast";
import { DragDropContext } from "react-beautiful-dnd";
import { useTaskManager } from "./useTaskManager";
import { useSelector } from "react-redux";
import {
  selectTodoTaskFilter,
  selectFilteredCards,
} from "../../../redux/plannerFilterSlice";
import { getPlannerTokenSharing } from "../../../sevices/apiSystemSettings";

function MyPlanner() {
  const [plannerToken, setPlannerToken] = useState(currentUserPlannerToken());
  const isMobile = useResponsive("down", "md");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const refreshToken = searchParams.get("refresh_token");
  const userId = searchParams.get("user_id");
  const { localTodos, handleDragEnd } = useTaskManager();
  const todoTaskFilter = useSelector(selectTodoTaskFilter);
  const filteredCards = useSelector(selectFilteredCards);
  const [filter, setFilter] = useState(todoTaskFilter ? todoTaskFilter : "All");
  const [removeSearchParams] = useRemoveMultipleParams();
  const domain =
    typeof window !== "undefined" ? window.location.hostname : "";
  const [plannerTokenSharingData, setPlannerTokenSharingData] = useState(null);
  const [isLoadingPlannerTokenSharing, setIsLoadingPlannerTokenSharing] = useState(false);

  useEffect(() => {
    if (domain) {
      setIsLoadingPlannerTokenSharing(true);
      getPlannerTokenSharing(domain)
        .then((response) => {
          setPlannerTokenSharingData(response?.data);
          if (response?.data?.data?.responseData?.enabled !== undefined) {
            localStorageInstance.setItem({
              key: "planner_token_sharing_enabled",
              value: response?.data?.data?.responseData?.enabled,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching planner token sharing:", error);
        })
        .finally(() => {
          setIsLoadingPlannerTokenSharing(false);
        });
    }
  }, [domain]);

  const plannerTokenSharingEnabled =
    plannerTokenSharingData?.data?.responseData?.enabled ?? false;

  useEffect(() => {
    if (token) {
      // apiGoogleCallback(code, scope)
      //   .then((response) => {
          setPlannerToken(token);
          localStorageInstance.setItem({
            key: "planner_access_token",
            value: token,
          });
          localStorageInstance.setItem({
            key: "planner_refresh_token",
            value: refreshToken,
          });
          localStorageInstance.setItem({
            key: "planner_user_id",
            value: userId,
          });
          removeSearchParams([
            "token",
            "refresh_token",
            "user_id",
          ]);
        // })
        // .catch((error) => {
        //   console.log("error :- ", error);
        //   toast.error(error?.message || "Something went wrong");
        //   removeSearchParams([
        //     "code",
        //     "scope",
        //     "prompt",
        //     "hd",
        //     "authuser",
        //     "state",
        //   ]);
        // });
    }
  }, [token]);

  // Apply filtering based on the selected filter
  const filteredTasks = localTodos
    .filter((task) => {
      if (filter === "All") {
        return true; // Show all tasks
      } else if (filter === "Assigned to me") {
        return Boolean(task.source_id);
      } else if (filter === "Mine") {
        return !Boolean(task.source_id);
      } else if (filter === "Completed") {
        return Boolean(task.completed_at);
      }
      return true; // Default fallback
    })
    .sort((a, b) => {
      // Move completed tasks to the end of the array
      const aCompleted = Boolean(a.completed_at);
      const bCompleted = Boolean(b.completed_at);
      return aCompleted === bCompleted ? 0 : aCompleted ? 1 : -1;
    });

  const onTaskDragEnd = useCallback(
    (result) => {
      // Use the unified drag handler from useTaskManager
      handleDragEnd(result, filteredTasks, filteredCards);
    },
    [handleDragEnd, filteredTasks, filteredCards]
  );

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div
        className={`my-planner-top-container ${
          isMobile ? "planner-mobile-view" : ""
        }`}
      >
        <DragDropContext onDragEnd={onTaskDragEnd}>
          <Grid
            container
            spacing={2}
            className="my-planner-grid-container"
            mt={0}
          >
            <Grid item xs={12} md={8} className="my-planner-left">
              {plannerTokenSharingEnabled || plannerToken ? (
                <MyPlannerTasks
                  filter={filter}
                  setFilter={setFilter}
                  filteredTasks={filteredTasks}
                />
              ) : !token && !isLoadingPlannerTokenSharing ? (
                <GoogleLogin setPlannerToken={setPlannerToken} />
              ) : (
                <div className="loader-center">
                  <Loader color="black" />
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={4} className="my-planner-right">
              <AllMyTask />
            </Grid>
          </Grid>
        </DragDropContext>
      </div>
    </GoogleOAuthProvider>
  );
}

export default MyPlanner;
